import { MCI_KR_VIEW_KEY_CONFIG } from './mciKrServiceOpsConfig';

/** Single source of truth for the gate name, to avoid drift across call sites and tests. */
export const MCI_KR_ATTRIBUTES_GATE = 'add_mci_kr_attributes_to_rovo_chat_analytics';

export type MciKrAttributes = {
	eligible_for_mci_plus_kr?: 1;
	eligible_for_ai_adopted_kr?: 1;
	service_or_ops?: 'service' | 'ops';
};

const MCI_KR_VIEW_KEY_CONFIG_ENTRIES = Object.entries(MCI_KR_VIEW_KEY_CONFIG);

/**
 * Matches each identifier against MCI_KR_VIEW_KEY_CONFIG by substring containment. A KR flag
 * is only included when a matched entry opts in — never sent as 0. service_or_ops is the
 * earliest-scanned match's value.
 */
export const mciKrAttributes = (identifiers: string[]): MciKrAttributes => {
	const matchedEntries = identifiers.flatMap((identifier) =>
		MCI_KR_VIEW_KEY_CONFIG_ENTRIES.filter(([key]) => identifier.includes(key)).map(
			([, entry]) => entry,
		),
	);

	if (matchedEntries.length === 0) {
		return {};
	}

	return {
		...(matchedEntries.some((entry) => entry.countsTowardMciPlusKr) && {
			eligible_for_mci_plus_kr: 1 as const,
		}),
		...(matchedEntries.some((entry) => entry.countsTowardAiAdoptedKr) && {
			eligible_for_ai_adopted_kr: 1 as const,
		}),
		service_or_ops: matchedEntries[0].serviceOrOps,
	};
};
